export default __webpack_public_path__ + "static/media/mariupol.b3672ecf.png";